import { Box, Input } from '@grupoboticario/flora-react'
import { FormikProps } from 'formik'
import { useTranslation } from 'react-i18next'

import Signature from './Signature'
import withForm from '../hocs/withForm'
import { Dispatcher } from '../config/schemaDispatcher'

const DispatcherFields = ({ getFieldProps, errors, touched, values, handleChange }: FormikProps<Dispatcher>) => {
  const { t } = useTranslation()

  return (
    <>
      <Box>
        <Input
          id="dispatcher-name"
          labelText={t('dispatcherName')}
          optionalText=""
          invalidText={t(errors.dispatcherName || 'requiredField', { field: t('dispatcherName'), number: 50 })}
          invalid={!!errors.dispatcherName && !!touched.dispatcherName}
          {...getFieldProps('dispatcherName')}
        />
      </Box>

      <Box>
        <Signature
          id="dispatcher-signature"
          label={t('dispatcherSignature')}
          onChange={handleChange('dispatcherSignature')}
          hasError={!!errors.dispatcherSignature && !!touched.dispatcherSignature}
          signature={values.dispatcherSignature}
        />
      </Box>
    </>
  )
}

const FormDispatcher = withForm(DispatcherFields)

export default FormDispatcher
